import { render, staticRenderFns } from "./FormRecepcion.vue?vue&type=template&id=f02d1f40&"
import script from "./FormRecepcion.vue?vue&type=script&lang=js&"
export * from "./FormRecepcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports